module.exports = __webpack_public_path__ + "img/城市交管.1f712721.png";